import script from "./PredictSNRView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PredictSNRView.vue?vue&type=script&setup=true&lang=ts"

import "./PredictSNRView.vue?vue&type=style&index=0&id=4827a617&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4827a617"]])

export default __exports__